export const sidebarConstants = {
  CHANGE: "SIDEBAR_CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  TOGGLE_SIDEBAR_DROPDOWN: "TOGGLE_SIDEBAR_DROPDOWN",
  GETNAVIGATION_REQUEST: 'SIDEBAR_GETNAVIGATION_REQUEST',
  GETNAVIGATION_SUCCESS: 'SIDEBAR_GETNAVIGATION_SUCCESS',
  GETNAVIGATION_FAILURE: 'SIDEBAR_GETNAVIGATION_FAILURE',
};